import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Repertoire } from './pages/Repertoire';
import { Booking } from './pages/Booking';
import { MemberProfile } from './pages/MemberProfile';
import { AudioSamples } from './pages/AudioSamples';
import { Referenzen } from './pages/Referenzen';
import { Kontakt } from './pages/Kontakt';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ThemeProvider data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <div className="flex flex-col min-h-screen w-full" data-id="element-3">
          <Navbar data-id="element-4" />
          <main className="flex-1" data-id="element-5">
            <Routes data-id="element-6">
              <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
              <Route path="/repertoire" element={<Repertoire data-id="element-10" />} data-id="element-9" />
              <Route path="/buchen" element={<Booking data-id="element-12" />} data-id="element-11" />
              <Route path="/mitglieder/:slug" element={<MemberProfile data-id="element-14" />} data-id="element-13" />
              <Route path="/audio" element={<AudioSamples data-id="element-16" />} data-id="element-15" />
              <Route path="/referenzen" element={<Referenzen data-id="element-18" />} data-id="element-17" />
              <Route path="/kontakt" element={<Kontakt data-id="element-20" />} data-id="element-19" />
            </Routes>
          </main>
          <Footer data-id="element-21" />
        </div>
      </ThemeProvider>
    </BrowserRouter>;
}